<template>
  <div ref="headerMobile"
       class="page-header__main"
       :class="{ 'page-header--has-top-banner': bannerInfo }"
  >
    <header-banner v-if="bannerInfo && isMobile" :banner-info="bannerInfo"></header-banner>
    <div class="header-main page-container page-container--new-header">
      <mobile-menu :catalog="catalog"></mobile-menu>
      <a href="/" class="header-sidebar__mobile-logo">
        <img src="/img/svgo/header/logo-new.svg" alt="">
      </a>
      <div class="header-sidebar__bottom-mobile-line">
        <header-sidebar :sidebar-menu="sidebarMenu" :need-to-hide-sidebar="isFixed"></header-sidebar>
        <search-bar :dispatch-action="!isMobile"></search-bar>
        <button type="button" @click="openMenuWithCatalog" class="header-sidebar__trigger mobile-action">
          <span class="header-sidebar__trigger__icon">
            <svg width="20"
                 height="20"
                 viewBox="0 0 20 20"
                 fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M4.13793 6.55172C5.47103 6.55172 6.55172 5.47103 6.55172 4.13793C6.55172 2.80483 5.47103 1.72414 4.13793 1.72414C2.80483 1.72414 1.72414 2.80483 1.72414 4.13793C1.72414 5.47103 2.80483 6.55172 4.13793 6.55172ZM4.13793 8.27586C6.42325 8.27586 8.27586 6.42325 8.27586 4.13793C8.27586 1.85261 6.42325 0 4.13793 0C1.85261 0 0 1.85261 0 4.13793C0 6.42325 1.85261 8.27586 4.13793 8.27586Z"
                    fill="#FF2F00"/>
              <path fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M15.8621 6.55172C17.1952 6.55172 18.2758 5.47103 18.2758 4.13793C18.2758 2.80483 17.1952 1.72414 15.8621 1.72414C14.529 1.72414 13.4483 2.80483 13.4483 4.13793C13.4483 5.47103 14.529 6.55172 15.8621 6.55172ZM15.8621 8.27586C18.1474 8.27586 20 6.42325 20 4.13793C20 1.85261 18.1474 0 15.8621 0C13.5767 0 11.7241 1.85261 11.7241 4.13793C11.7241 6.42325 13.5767 8.27586 15.8621 8.27586Z"
                    fill="#FF2F00"/>
              <path fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M15.8621 18.2758C17.1952 18.2758 18.2758 17.1952 18.2758 15.8621C18.2758 14.529 17.1952 13.4483 15.8621 13.4483C14.529 13.4483 13.4483 14.529 13.4483 15.8621C13.4483 17.1952 14.529 18.2758 15.8621 18.2758ZM15.8621 20C18.1474 20 20 18.1474 20 15.8621C20 13.5767 18.1474 11.7241 15.8621 11.7241C13.5767 11.7241 11.7241 13.5767 11.7241 15.8621C11.7241 18.1474 13.5767 20 15.8621 20Z"
                    fill="#FF2F00"/>
              <path fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M4.13793 18.2758C5.47103 18.2758 6.55172 17.1952 6.55172 15.8621C6.55172 14.529 5.47103 13.4483 4.13793 13.4483C2.80483 13.4483 1.72414 14.529 1.72414 15.8621C1.72414 17.1952 2.80483 18.2758 4.13793 18.2758ZM4.13793 20C6.42325 20 8.27586 18.1474 8.27586 15.8621C8.27586 13.5767 6.42325 11.7241 4.13793 11.7241C1.85261 11.7241 0 13.5767 0 15.8621C0 18.1474 1.85261 20 4.13793 20Z"
                    fill="#FF2F00"/>
            </svg>
          </span>
          <span class="header-sidebar__trigger__text">
            {{ $t('up.menu.catalog') }}
          </span>
        </button>
      </div>
      <user-actions></user-actions>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import UserActions from '@/components/header/UserActions'
import SearchBar from '@/components/search-bar/SearchBar'
import HeaderSidebar from '@/components/header/HeaderSidebar'
import MobileMenu from '@/components/header/MobileMenu.vue'

export default {
  name: 'HeaderMain',
  components: {
    UserActions,
    SearchBar,
    MobileMenu,
    HeaderSidebar
  },
  props: {
    bannerInfo: {
      type: Object
    },
    sidebarMenu: {
      type: Array,
      default: () => []
    },
    catalog: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      isMainPage: false,
      fixedHeader: false,
      isMenuBtnClicked: false,
      windowWidth: window.innerWidth,
      isFixed: false,
      lastScrollTop: 0,
      scrollDown: false,
      headerInfoHeight: 0,
      headerMobileHeight: 0,
      top: window.pageYOffset
    }
  },
  computed: {
    ...mapGetters(['isChangedBonuses']),
    ...mapState({
      isInputFocused: state => state.search.isInputFocused
    }),
    isMobile () {
      return this.windowWidth < 1024
    }
  },
  methods: {
    handleMenuBtnClick () {
      this.isMenuBtnClicked = true
    },
    openMenuWithCatalog () {
      this.handleMenuBtnClick()
    },
    handleResize () {
      this.windowWidth = window.innerWidth
      this.setPaddingSpace(this.isFixed)
      this.getHeaderHeight()
    },
    getHeaderHeight () {
      setTimeout(() => {
        this.headerInfoHeight = document.querySelector('.page-header__info') ? document.querySelector('.page-header__info').clientHeight : 0
        this.headerMobileHeight = this.$refs.headerMobile?.clientHeight
      }, 0)
    },
    toggleFixedStatus () {
      this.top = window.pageYOffset
      const scrollGap = this.isMainPage ? 820 : 40
      const height = this.isMobile ? this.bannerInfo ? 80 : 0 : scrollGap
      this.isFixed = this.isMobile && !this.bannerInfo ? false : this.top > (parseInt(this.headerInfoHeight) + height)
    },
    handleScroll () {
      this.toggleFixedStatus()
    },
    setPaddingSpace (value) {
      const paddingFix = document.getElementsByTagName('body')[0]
      const paddingValue = () => {
        if (this.isMobile) {
          if (this.bannerInfo) {
            return '84px'
          }
          return '50px'
        } else {
          if (!value) {
            return '0'
          }
          return '66px'
        }
      }
      const setPaddingValue = (value) => {
        this.fixedHeader = value
        paddingFix.style.setProperty('padding-top', paddingValue())
      }
      if (value && this.isMainPage && !this.isMobile) {
        setTimeout(() => {
          setPaddingValue(value)
        }, 100)
      } else {
        setPaddingValue(value)
      }
    }
  },
  mounted () {
    window.addEventListener('resize', this.handleResize)
    this.getHeaderHeight()
    window.addEventListener('scroll', this.handleScroll)
    this.isMainPage = window.location.pathname === '/' || window.location.pathname === '/uk/'
    this.setPaddingSpace(this.isFixed)
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('scroll', this.handleScroll)
  },
  watch: {
    isFixed (value) {
      this.setPaddingSpace(value)
    },
    fixedHeader (val) {
      const headerWrapper = document.querySelector('.header-main-wrap')
      if (headerWrapper) {
        if (val) {
          headerWrapper.classList.add('header-main-wrap--fixed')
        } else {
          headerWrapper.classList.remove('header-main-wrap--fixed')
        }
      }
    }
  }
}
</script>
<style lang="sass">
.page-header--new-sidebar
  &.height-fix
    padding-bottom: 65px

.page-header--new-sidebar .page-header__main
  border-bottom: none !important

  .header-main
    background-color: #333
</style>
<style scoped lang="sass">
.page-header__main
  z-index: 14
  border-bottom: 1px solid $nd-border-color
  transform: translateY(0)
  transition: transform .1s
  +mmax($tablet--hor)
    border-bottom: none

.header-mobile--fixed
  transform: translateY(0)

.page-header--new-sidebar .header-mobile--fixed.header-mobile--hide
  transform: translateY(-165px)

.header-mobile--fixed.header-mobile--hide
  transform: translateY(-50px)

.header-main
  position: relative
  padding: 0 15px 0 7px
  z-index: 4
  min-height: 50px

  +mmin($tablet--hor)
    padding: 0 15px
    position: static

.header-catalog
  display: none

  +mmin($tablet--hor)
    display: block
</style>
